<template lang="pug">
div
  span.term-title(:class="{'term-title-children': term.descendants_count}") {{ $langTitle(term) }}
  div.term-period-years(v-if="term.startYear")
    span {{term.startYear}} - {{ term.endYear }}
  q-tooltip(v-if="term.tooltip" content-class="bg-accent")
    .text-caption {{ term.tooltip }}
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

export default @Component({

  props: {
    term: Object
  }
})
class PeriodTaxonomyViewComponent extends Vue {
}
</script>
<style lang="stylus">

.term-title
  font-weight bold

.term-title-children
  color $primary

.term-period-years
  color gray
  padding-left 20px
  font-size smaller
  line-height 70%

.taxonomy-title
  color $secondary
</style>
